import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  TextField,
  IconButton,
  MenuItem,
  Autocomplete,
  CircularProgress,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CreatableSelect from "react-select/creatable";
import { headingStyle, xBtn } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import { textfieldTextBlueBr } from "../../style/PharmacyStyle";
import {
  orangeButton,
  primaryBtnTeal,
  textfieldTextBlueBorder,
} from "../../style/PatientDetailsStyle";
import {
  generateMedicine,
  generateMedicineSalt,
  ExtractMedicineSummaryV1,
} from "../../connections/postApi";
import { getMedicineSaltPharmacySearch } from "../../connections/getApi";
import { normalizeMedicineSalt } from "../../utils/medicineSaltUtils";
import { showToast } from "../../utils/toastUtil";
import {
  autoFocusOffWithOutBorder,
  drTableGreen,
  drTableRowBlueBg,
} from "../../style/PatinetFormStyle";
import medicines_icon from "../../assets/medicine.svg";
import UseFetchPackList from "../../helper/UseFetchPackList";
import UseFetchFormType from "../../helper/UseFetchFormType";
import UseGetAllMedicineSaltList from "../../helper/UseGetAllMedicineSaltList";
import UseMedicineSaltPharmacy from "../../helper/UseMedicineSaltPharmacy";
import useDebounce from "../../hooks/UseDebounce";
import UseFetchSearchSaltsPharmacy from "../../helper/UseFetchSearchSaltsPharmacy";
import { PercentIcon } from "lucide-react";

const NewMedicines = ({ onClose, refetch }) => {
  const { data: packList } = UseFetchPackList();
  const { data: formTypeList } = UseFetchFormType();
  // const { data: medicineSaltList } = UseGetAllMedicineSaltList();
  // const { data: medicineSaltList } = UseMedicineSaltPharmacy();

  const [medicineSaltSearchInput, setMedicineSaltSearchInput] = useState("");

  // console.log(mediDetails?.flat_price, 'mediDetails?.flat_price')
  const handleMedicineSaltChange = (value) => {
    // e.preventDefault();
    setMedicineSaltSearchInput(value);
  };

  // const { data: medicineSaltList } = UseMedicineSaltPharmacy();
  const debouncedInputMedicine = useDebounce(medicineSaltSearchInput, 400);

  const { data: medicineSaltList, isLoading: medicineSaltLoading } =
    UseFetchSearchSaltsPharmacy(debouncedInputMedicine, 1, 10);
  const [fieldOptions, setFieldOptions] = useState({
    formTypeList: JSON.parse(localStorage.getItem("formTypeList")) || [],
    medicineSaltList:
      JSON.parse(localStorage.getItem("medicineSaltList")) || [],
    packList: JSON.parse(localStorage.getItem("packList")) || [],
  });

  const [formState, setFormState] = useState({
    name: "",
    company: "",
    srp: "",
    form_type: "",
    flat_price: "",
    auto_purchase_threshold: "",
    medicine_salt_id: "",
    medicine_salt: "",
    discount: "",
    hsn_name: "",
  });

  const [errors, setErrors] = useState({});
  const [showAmount, setShowAmount] = useState(true);
  const [batches, setBatches] = useState([
    {
      batch_no: "",
      expiry_date: "",
      amount: "",
      purchase_cost: "",
      // form_type: "",
      cgst: "",
      sgst: "",
      packing: "",
      stock_left: "",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [autoFillSaltLoading, setAutoFillSaltLoading] = useState(false);
  const [saltCreating, setSaltCreating] = useState(false);
  const [saltInputValue, setSaltInputValue] = useState("");

  const validateForm = () => {
    const newErrors = {};

    if (!formState.name) newErrors.name = "Medicine name is required.";
    // if (!formState.company) newErrors.company = "Company is required.";
    // if (!formState.srp || isNaN(formState.srp)) newErrors.srp = "Valid SRP is required.";
    if (!formState.form_type) newErrors.form_type = "Form type is required.";
    // if (!formState.flat_price || isNaN(formState.flat_price)) newErrors.flat_price = "Flat price is required.";
    // if (!formState.auto_purchase_threshold || isNaN(formState.auto_purchase_threshold)) {
    //   newErrors.auto_purchase_threshold = "Auto purchase threshold is required.";
    // }
    // if (!formState.medicine_salt || isNaN(formState.medicine_salt)) {
    //   newErrors.medicine_salt = "Medicine salt  is required.";
    // }
    // if (!formState.gst || isNaN(formState.gst)) newErrors.gst = "Valid GST is required.";
    // if (!formState.discount || isNaN(formState.discount)) newErrors.discount = "Valid discount is required.";
    // if (!formState.hsn_name) newErrors.hsn_name = "HSN code is required.";
    // if (!formState.cgst || isNaN(formState.cgst)) newErrors.cgst = "Valid CGST is required.";
    // if (!formState.sgst || isNaN(formState.sgst)) newErrors.sgst = "Valid SGST is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if there are no errors
  };

  // console.log(batches)
  //handle form change
  // const handleFormChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormState((prev) => ({
  //     ...prev,
  //     [name]: value,
  //     ...(name === "gst" && {
  //       cgst: value ? (parseFloat(value) / 2).toString() : "",
  //       sgst: value ? (parseFloat(value) / 2).toString() : "",
  //     }),
  //   }));
  //   setErrors((prev) => ({ ...prev, [name]: undefined }));
  // };
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "flat_price") {
      const numVal = parseFloat(value);
      setShowAmount(!value || isNaN(numVal) || numVal <= 0);
    }

    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const handleAddRow = () => {
    setBatches((prev) => [
      ...prev,
      {
        batch_no: "",
        expiry_date: "",
        amount: "",
        purchase_cost: "",
        // form_type: "",
        cgst: "",
        sgst: "",
        packing: "",
        stock_left: "",
      },
    ]);
  };

  const handleChange = (index, field, value) => {
    const newBatchArr = [...batches];
    newBatchArr[index] = { ...newBatchArr[index], [field]: value };
    setBatches(newBatchArr);
  };

  useEffect(() => {
    if (packList?.payload?.packing?.length > 0) {
      localStorage.setItem(
        "packList",
        JSON.stringify(packList.payload.packing),
      );
      setFieldOptions((prev) => ({
        ...prev,
        packList: packList.payload.packing,
      }));
    }

    if (formTypeList?.payload?.form_types?.length > 0) {
      localStorage.setItem(
        "formTypeList",
        JSON.stringify(formTypeList?.payload?.form_types),
      );
      setFieldOptions((prev) => ({
        ...prev,
        formTypeList: formTypeList?.payload?.form_types,
      }));
    }

    // console.log(formTypeList?.payload?.form_types, 'formTypeList?.payload?.form_types')

    if (medicineSaltList?.payload?.medicine_salts?.length > 0) {
      // const transformedData = medicineSaltList.payload.medicine_salts.map((salt) => [id: salt.id, name: salt.name])

      const transformedData = medicineSaltList.payload.medicine_salts.map(
        (salt) => [salt.id, salt.name],
      );

      localStorage.setItem("medicineSaltList", JSON.stringify(transformedData));
      setFieldOptions((prev) => ({
        ...prev,
        medicineSaltList: transformedData,
      }));
    }
  }, [formTypeList, medicineSaltList, packList]);

  const handleDeleteRow = (index) => {
    setBatches(
      (prev) => prev.filter((_, i) => i !== index), // Keep rows that don't match the index
    );
  };

  const handleKeyDown = (e, index, field) => {
    if (field === "batch_no" && e.key === "Enter") {
      if (!batches[index]?.batch_no) {
        setTimeout(() => document.getElementById(`submit`).focus(), 0);
        return;
      }
      setTimeout(
        () => document.getElementById(`expiry_date-${index}`).focus(),
        0,
      );
    }

    if (field === "expiry_date" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`amount-${index}`).focus(), 0);
    }

    if (field === "amount" && e.key === "Enter") {
      setTimeout(
        () => document.getElementById(`purchase_cost-${index}`).focus(),
        0,
      );
    }

    if (field === "purchase_cost" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`packing-${index}`).focus(), 0);
    }

    // if (field === "form_type" && e.key === "Enter") {
    //   setTimeout(() => document.getElementById(`packing-${index}`).focus(), 0)
    // }

    if (field === "packing" && e.key === "Enter") {
      setTimeout(
        () => document.getElementById(`stock_left-${index}`).focus(),
        0,
      );
    }

    if (field === "stock_left" && e.key === "Enter") {
      if (batches?.length > index + 1) {
        setTimeout(
          () => document.getElementById(`batch_no-${index + 1}`).focus(),
          100,
        );
      } else {
        handleAddRow();
        setTimeout(
          () => document.getElementById(`batch_no-${index + 1}`).focus(),
          100,
        );
      }
    }
  };

  const handleAutoFillSalt = async () => {
    if (!formState.name?.trim()) {
      showToast("Enter medicine name first to auto-fill salt", "ERROR");
      return;
    }
    setAutoFillSaltLoading(true);
    try {
      // Step 1: get AI suggestion
      const res = await ExtractMedicineSummaryV1(
        "",
        "medicine_salt",
        "GlobalAiContext",
        null,
        null,
        [formState.name],
      );
      const salts = res?.payload?.summaries?.medicines
        ?.map((m) => m?.salt)
        .filter(Boolean);
      const salt = salts?.join(" + ") || null;
      if (!salt) {
        showToast("Could not determine salt. Please enter manually.", "ERROR");
        return;
      }
      const normalized = normalizeMedicineSalt(salt);

      // Step 2: search if salt already exists
      const searchRes = await getMedicineSaltPharmacySearch(normalized, 1, 5);
      const existing = searchRes?.payload?.medicine_salts || [];
      const match = existing.find(
        (s) => s.name?.toLowerCase().trim() === normalized.toLowerCase().trim(),
      );

      if (match) {
        // Found — auto-select without creating
        setFieldOptions((prev) => ({
          ...prev,
          medicineSaltList: prev.medicineSaltList?.some(
            ([id]) => id === match.id,
          )
            ? prev.medicineSaltList
            : [...(prev.medicineSaltList || []), [match.id, match.name]],
        }));
        setFormState((prev) => ({
          ...prev,
          medicine_salt_id: match.id,
          medicine_salt: match.name,
        }));
        setSaltInputValue("");
        showToast(`Salt "${match.name}" found & selected`, "SUCCESS");
      } else {
        // Not found — create then auto-select
        const result = await generateMedicineSalt({
          medicine_salt: { name: normalized },
          medicines_ids: [],
        });
        if (result?.status?.status === "SUCCESS") {
          const newSalt = result?.payload?.medicine_salt || result?.payload;
          const newId = newSalt?.id || newSalt?.medicine_salt_id || null;
          const newName =
            newSalt?.name || newSalt?.medicine_salt_name || normalized;
          setFieldOptions((prev) => ({
            ...prev,
            medicineSaltList: [
              ...(prev.medicineSaltList || []),
              [newId, newName],
            ],
          }));
          setFormState((prev) => ({
            ...prev,
            medicine_salt_id: newId,
            medicine_salt: newName,
          }));
          setSaltInputValue("");
          showToast(
            result?.status?.message || "Salt created & selected",
            "SUCCESS",
          );
        } else {
          showToast(
            result?.status?.message || "Failed to create salt",
            "ERROR",
          );
        }
      }
    } catch {
      showToast("Failed to auto-fill salt", "ERROR");
    } finally {
      setAutoFillSaltLoading(false);
    }
  };

  const handleCreateSalt = async (inputValue) => {
    const normalized = normalizeMedicineSalt(inputValue);
    setSaltCreating(true);
    try {
      const result = await generateMedicineSalt({
        medicine_salt: { name: normalized },
        medicines_ids: [],
      });
      if (result?.status?.status === "SUCCESS") {
        const newSalt = result?.payload?.medicine_salt || result?.payload;
        const newId = newSalt?.id || newSalt?.medicine_salt_id || null;
        const newName =
          newSalt?.name || newSalt?.medicine_salt_name || normalized;
        setFieldOptions((prev) => ({
          ...prev,
          medicineSaltList: [
            ...(prev.medicineSaltList || []),
            [newId, newName],
          ],
        }));
        setFormState((prev) => ({
          ...prev,
          medicine_salt_id: newId,
          medicine_salt: newName,
        }));
        setSaltInputValue("");
        showToast(
          result?.status?.message || "Salt created successfully",
          "SUCCESS",
        );
      } else {
        showToast(result?.status?.message || "Failed to create salt", "ERROR");
      }
    } catch {
      showToast("Failed to create salt", "ERROR");
    } finally {
      setSaltCreating(false);
    }
  };

  // If the user typed/pasted a salt name but never clicked "Create" or picked an
  // option, resolve it on submit: reuse an existing match, otherwise create it.
  const resolveTypedSalt = async () => {
    const typed = saltInputValue?.trim();
    if (!typed) return null;
    const normalized = normalizeMedicineSalt(typed);
    try {
      const searchRes = await getMedicineSaltPharmacySearch(normalized, 1, 5);
      const existing = searchRes?.payload?.medicine_salts || [];
      const match = existing.find(
        (s) => s.name?.toLowerCase().trim() === normalized.toLowerCase().trim(),
      );
      if (match) return { id: match.id, name: match.name };

      const result = await generateMedicineSalt({
        medicine_salt: { name: normalized },
        medicines_ids: [],
      });
      if (result?.status?.status === "SUCCESS") {
        const newSalt = result?.payload?.medicine_salt || result?.payload;
        return {
          id: newSalt?.id || newSalt?.medicine_salt_id || null,
          name: newSalt?.name || newSalt?.medicine_salt_name || normalized,
        };
      }
    } catch {
      // fall through — medicine can still be created without a salt
    }
    return null;
  };

  const handleCreateMedicine = async (e) => {
    e?.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    setLoading(true);
    try {
      // Resolve a typed-but-not-created salt before building the payload.
      // Any leftover typed text (saltInputValue) means the user typed/pasted a
      // salt without committing it — create/attach it, overriding any previous
      // selection.
      let medicine_salt_id = formState.medicine_salt_id;
      let medicine_salt = formState.medicine_salt;
      if (saltInputValue?.trim()) {
        const resolved = await resolveTypedSalt();
        if (resolved?.id) {
          medicine_salt_id = resolved.id;
          medicine_salt = resolved.name;
        }
      }

      const payload = {
        medicine: {
          ...formState,
          medicine_salt_id,
          medicine_salt,
          discount:
            formState.flat_price && parseFloat(formState.flat_price) > 0
              ? 0
              : formState.discount || 0,
          ...(batches.length > 0 && {
            medicine_batches_attributes: batches.map((batch) => ({
              ...batch,
              cgst: (parseFloat(batch.cgst) || 0).toString(),
              sgst: (parseFloat(batch.sgst) || 0).toString(),
              gst: (
                (parseFloat(batch.cgst) || 0) + (parseFloat(batch.sgst) || 0)
              ).toString(),
            })),
          }),
        },
      };

      const result = await generateMedicine(payload);
      console.log(result);
      showToast(
        result?.status?.message || result?.status?.status,
        result?.status?.status,
      );
      // if (result?.status?.status === "SUCCESS") {
      //   showToast("Purchase Order Created  Successfully" ,"SUCCESS");
      //   // navigate("/admin/purchase_orders");
      // }
      if (result?.status?.status === "SUCCESS") {
        refetch();
        onClose();
      }
    } catch (error) {
      showToast(error.message, "ERROR");
    } finally {
      setLoading(false);
    }
  };

  console.log(formState, "formTypeList");

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={4}
            position="sticky"
          >
            <Box></Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={medicines_icon}
                alt=""
                sx={{
                  color: "neutral.navyBlue",
                  marginBottom: "4px",
                  marginRight: "8px",
                }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                gutterBottom
                sx={headingStyle}
              >
                New Medicines
              </Typography>
            </Box>
            <IconButton sx={{ marginBottom: "r0em" }} onClick={onClose}>
              <CloseIcon size="small" sx={{ color: "red" }} />
            </IconButton>
          </Box>

          <Grid container spacing={2}>
            <Grid item sm={2}>
              <TextField
                value={formState?.name}
                fullWidth
                placeholder="Medicine name "
                name="name"
                onChange={(e) => handleFormChange(e)}
                sx={autoFocusOffWithOutBorder}
                error={!!errors["name"]}
                helperText={errors["name"]}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                value={formState?.company}
                fullWidth
                placeholder="Company "
                name="company"
                onChange={(e) => handleFormChange(e)}
                sx={autoFocusOffWithOutBorder}
                error={!!errors["company"]}
                helperText={errors["company"]}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                value={formState?.srp}
                fullWidth
                placeholder="SRP "
                name="srp"
                onChange={(e) => handleFormChange(e)}
                sx={autoFocusOffWithOutBorder}
                error={!!errors["srp"]}
                helperText={errors["srp"]}
              />
            </Grid>
            <Grid item sm={2}>
              {/* <TextField value={formState?.form_type} fullWidth placeholder="Form type " name="form_type" onChange={(e) => handleFormChange(e)} sx={autoFocusOffWithOutBorder}
                error={!!errors['form_type']}
                helperText={errors['form_type']}
              /> */}

              <Autocomplete
                clearOnEscape={false}
                clearIcon={null}
                sx={{
                  ...autoFocusOffWithOutBorder,
                  backgroundColor: "neutral.white",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    height: "40px",
                    padding: "9px !important",
                    "& input": {
                      padding: "8px",
                      fontSize: "14px",
                    },
                    "& .MuiAutocomplete-popupIndicator": {
                      display: "none",
                    },
                  },
                }}
                name="form_type"
                options={
                  fieldOptions?.formTypeList?.filter((option) => option) || []
                }
                getOptionLabel={(option) => option?.label || ""}
                value={
                  fieldOptions?.formTypeList?.find(
                    (option) => option.value === formState.form_type,
                  ) || null
                }
                onChange={(e, value) => {
                  setFormState((prev) => ({
                    ...prev,
                    form_type: value?.value || "",
                  }));
                  setErrors((prev) => ({
                    ...prev,
                    form_type: undefined,
                  }));
                }}
                id="form_type"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Form type"
                    error={!!errors.form_type}
                    helperText={errors["form_type"]}
                  />
                )}
                renderOption={(props, option) => (
                  <MenuItem {...props} key={option.value}>
                    {option.value}
                  </MenuItem>
                )}
                isOptionEqualToValue={(option, value) =>
                  option?.value === value?.value
                }
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                fullWidth
                onChange={(e) => {
                  // const value = Number(e.target.value);
                  // if (value > 0) {
                  handleFormChange(e);
                  // }
                }}
                onBlur={(e) => {
                  const rawValue = e.target.value;
                  const value = Number(rawValue);
                  if (rawValue === "") {
                    // Allow empty value
                    setErrors((prev) => ({
                      ...prev,
                      flat_price: "",
                    }));
                    setShowAmount(true);
                  } else if (value <= 0 || isNaN(value)) {
                    setErrors((prev) => ({
                      ...prev,
                      flat_price: "Flat Price must be greater than 0",
                    }));
                    setShowAmount(true);
                  } else {
                    setErrors((prev) => ({
                      ...prev,
                      flat_price: "",
                    }));
                    setShowAmount(false);
                  }
                }}
                value={formState.flat_price}
                name="flat_price"
                placeholder="Flat Price"
                type="number"
                required
                inputProps={{ min: 1 }}
                variant="outlined"
                sx={{ ...autoFocusOffWithOutBorder }}
                error={!!errors.flat_price}
                helperText={errors.flat_price}
              />
            </Grid>

            <Grid item sm={2}>
              <TextField
                fullWidth
                onChange={(e) => handleFormChange(e)}
                value={formState?.auto_purchase_threshold}
                name="auto_purchase_threshold"
                placeholder="Auto purchase"
                type="number"
                required
                variant="outlined"
                sx={{ ...autoFocusOffWithOutBorder }}
                error={!!errors.auto_purchase_threshold}
                helperText={errors.auto_purchase_threshold}
              />
            </Grid>

            <Grid item sm={5}>
              <Box display="flex" alignItems="center" gap="4px">
                <Box sx={{ flexGrow: 1 }}>
                  <CreatableSelect
                    isClearable
                    isLoading={medicineSaltLoading || saltCreating}
                    inputValue={saltInputValue}
                    onInputChange={(value, { action }) => {
                      if (action !== "input-blur" && action !== "menu-close") {
                        setSaltInputValue(value);
                        handleMedicineSaltChange(value);
                      }
                    }}
                    value={
                      formState.medicine_salt
                        ? {
                            value:
                              formState.medicine_salt_id ||
                              formState.medicine_salt,
                            label: formState.medicine_salt,
                          }
                        : null
                    }
                    onChange={(option) => {
                      handleFormChange({
                        target: {
                          name: "medicine_salt_id",
                          value: option?.value ?? "",
                        },
                      });
                      handleFormChange({
                        target: {
                          name: "medicine_salt",
                          value: option?.label ?? "",
                        },
                      });
                      if (option) setSaltInputValue("");
                    }}
                    onCreateOption={handleCreateSalt}
                    options={(fieldOptions?.medicineSaltList || []).map(
                      ([id, name]) => ({ value: id, label: name }),
                    )}
                    formatCreateLabel={(input) =>
                      `Create "${normalizeMedicineSalt(input)}"`
                    }
                    formatOptionLabel={(option, { context }) =>
                      context === "menu" ? (
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          {option?.__isNew__ ? (
                            <AddCircleIcon
                              sx={{ fontSize: 18, color: "#1b7f3b" }}
                            />
                          ) : (
                            <ScienceOutlinedIcon
                              sx={{ fontSize: 18, color: "#7a869a" }}
                            />
                          )}
                          <span>{option.label}</span>
                        </Box>
                      ) : (
                        option.label
                      )
                    }
                    placeholder="Medicine salt"
                    styles={{
                      container: (base) => ({ ...base, flexGrow: 1 }),
                      control: (base, state) => ({
                        ...base,
                        borderRadius: "15px",
                        minHeight: "40px",
                        fontSize: "14px",
                        fontFamily: "Outfit",
                        backgroundColor: "#fff",
                        borderColor: state.isFocused
                          ? "#2e37a4"
                          : "rgba(46,55,164,0.1)",
                        boxShadow: state.isFocused
                          ? "0 0 0 1px #2e37a4"
                          : "none",
                      }),
                      option: (base, state) => ({
                        ...base,
                        cursor: "pointer",
                        ...(state.data?.__isNew__
                          ? {
                              color: "#1b7f3b",
                              fontWeight: 600,
                              backgroundColor: state.isFocused
                                ? "#d6f0df"
                                : "#eafaf0",
                            }
                          : {
                              color: "#3a3a3a",
                              backgroundColor: state.isFocused
                                ? "#f0f7ff"
                                : "#fff",
                            }),
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999999,
                        fontFamily: "Outfit",
                        fontSize: "14px",
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999999 }),
                    }}
                    menuPortalTarget={document.body}
                  />
                </Box>
                <Tooltip
                  title={
                    formState.name?.trim()
                      ? "Get medicine salt suggestion from AI"
                      : "Enter medicine name first"
                  }
                  placement="top"
                >
                  <span>
                    <IconButton
                      onClick={handleAutoFillSalt}
                      disabled={!formState.name?.trim() || autoFillSaltLoading}
                      sx={{
                        color: formState.name?.trim()
                          ? "#2e7d32"
                          : "action.disabled",
                        "&:hover": {
                          backgroundColor: "#e0f4f7",
                          color: "#0097B2",
                        },
                        p: "6px",
                      }}
                    >
                      {autoFillSaltLoading ? (
                        <CircularProgress size={16} sx={{ color: "#2e7d32" }} />
                      ) : (
                        <AutoFixHighIcon fontSize="small" />
                      )}
                    </IconButton>
                  </span>
                </Tooltip>
              </Box>
            </Grid>

            {!(
              formState.flat_price && parseFloat(formState.flat_price) > 0
            ) && (
              <Grid item sm={2}>
                <TextField
                  fullWidth
                  onChange={(e) => handleFormChange(e)}
                  value={formState.discount}
                  name="discount"
                  placeholder="Discount"
                  type="Discount"
                  required
                  variant="outlined"
                  sx={{ ...autoFocusOffWithOutBorder }}
                  error={!!errors.discount}
                  helperText={errors.discount}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PercentIcon size={18} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            )}

            <Grid item sm={2}>
              <TextField
                fullWidth
                onChange={(e) => handleFormChange(e)}
                value={formState.mobile}
                name="hsn_name"
                placeholder="HSN code"
                type="number"
                required
                variant="outlined"
                sx={{ ...autoFocusOffWithOutBorder }}
                error={!!errors.hsn_name}
                helperText={errors.hsn_name}
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <TableContainer sx={{ mt: 2, width: "100%", overflowX: "auto" }}>
              <Table sx={{ minWidth: 1400 }}>
                <TableHead stickyHeader>
                  <TableRow sx={{ ...drTableGreen, textAlign: "center" }}>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        borderTopLeftRadius: "20px",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Batches
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Expiry
                      </Typography>
                    </TableCell>

                    {showAmount && (
                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          variant="body1_text_bold"
                          sx={{ color: "neutral.black" }}
                        >
                          Amount
                        </Typography>
                      </TableCell>
                    )}

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Purchase cost
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        CGST
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        SGST
                      </Typography>
                    </TableCell>

                    {/*
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: 'neutral.white',
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      Form type
                    </TableCell> */}

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Packing
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "4px",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Stock left
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        p: "4px",
                        textAlign: "center",
                        borderTopRightRadius: "20px",
                      }}
                    >
                      <IconButton
                        onClick={handleAddRow}
                        sx={{
                          ...orangeButton,
                          marginLeft: "7px",
                          marginY: "2px",
                        }}
                      >
                        <AddIcon
                          sx={{
                            color: "neutral.white",
                            width: "30px",
                            height: "32px",
                            padding: "0px",
                          }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {batches?.map((item, index) => (
                    <TableRow sx={{ padding: "0px", margin: "0px" }}>
                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "14.28%",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          placeholder="Batch no"
                          value={item?.batch_no}
                          onChange={(e) => {
                            handleChange(index, "batch_no", e.target.value);
                          }}
                          id={`batch_no-${index}`}
                          onKeyDown={(e) => handleKeyDown(e, index, "batch_no")}
                          sx={textfieldTextBlueBr}
                        ></TextField>
                      </TableCell>

                      {/* Quantity Date Field */}
                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "14.28%",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          placeholder="expiry"
                          value={item?.expiry_date}
                          onChange={(e) => {
                            handleChange(index, "expiry_date", e.target.value);
                          }}
                          sx={textfieldTextBlueBr}
                          name="expiry_date"
                          fullWidth
                          type="date"
                          id={`expiry_date-${index}`}
                          onKeyDown={(e) =>
                            handleKeyDown(e, index, "expiry_date")
                          }
                          inputProps={{
                            min: new Date().toISOString().split("T")[0],
                          }}
                        />
                      </TableCell>

                      {showAmount && (
                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            width: "14.28%",
                            color: "neutral.white",
                            p: "4px",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            placeholder="Amount"
                            sx={textfieldTextBlueBr}
                            fullWidth
                            value={item?.amount}
                            onChange={(e) => {
                              handleChange(index, "amount", e.target.value);
                            }}
                            id={`amount-${index}`}
                            onKeyDown={(e) => handleKeyDown(e, index, "amount")}
                            name="amount"
                            type="number"
                          />
                        </TableCell>
                      )}

                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "14.28%",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          placeholder="Purchase cost"
                          value={item?.purchase_cost}
                          onChange={(e) => {
                            handleChange(
                              index,
                              "purchase_cost",
                              e.target.value,
                            );
                          }}
                          name="purchase_cost"
                          sx={textfieldTextBlueBr}
                          id={`purchase_cost-${index}`}
                          onKeyDown={(e) =>
                            handleKeyDown(e, index, "purchase_cost")
                          }
                          fullWidth
                          type="number"
                        />
                      </TableCell>

                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "14.28%",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          placeholder="CGST"
                          value={item?.cgst}
                          onChange={(e) =>
                            handleChange(index, "cgst", e.target.value)
                          }
                          sx={textfieldTextBlueBr}
                          fullWidth
                          type="number"
                        />
                      </TableCell>

                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "14.28%",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          placeholder="SGST"
                          value={item?.sgst}
                          onChange={(e) =>
                            handleChange(index, "sgst", e.target.value)
                          }
                          sx={textfieldTextBlueBr}
                          fullWidth
                          type="number"
                        />
                      </TableCell>

                      {/* <TableCell
                        variant="body1_text_bold"
                        sx={{
                          borderTopLeftRadius: "20px",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                          minWidth: "120px",
                        }}
                      >
                        <Autocomplete
                          clearOnEscape={false}
                          clearIcon={null}
                          sx={{
                            ...textfieldTextBlueBorder,
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "10px",
                              height: "40px",
                              padding: "9px !important",
                              "& input": {
                                padding: "8px",
                                fontSize: "14px",
                              },
                              "& .MuiAutocomplete-popupIndicator": {
                                display: "none", // Hides the dropdown icon
                              },
                            },
                          }}
                          options={
                            fieldOptions?.formTypeList?.filter(
                              (option) => option
                            ) || []
                          } // Filter out invalid entries
                          getOptionLabel={(option) => option?.label || ""} // Use the string value directly
                          inputValue={item?.form_type || ""} // Handle input display safely
                          onInputChange={(e, value) => {
                            handleChange(index, "form_type", value, e); // Update the form state on input change
                          }}
                          onChange={(e, value) => {
                            if (value) {
                              // Assuming `value` is a string directly
                              // console.log(value);
                              handleChange(index, "form_type", value.value);
                            }
                          }}
                          id={`form_type-${index}`}
                          onKeyDown={(e) => handleKeyDown(e, index, "form_type")}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Form type"
                              error={!!errors.form_type}
                            />
                          )}
                          renderOption={(props, option) => (
                            // <MenuItem {...props} key={option}>
                            //   {option}
                            // </MenuItem>
                            <MenuItem {...props} key={option.value}>
                              {option.value}
                            </MenuItem>
                          )}
                          // isOptionEqualToValue={(option, value) =>
                          //   option === value
                          // }
                          isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        // Compare values directly
                        />
                      </TableCell> */}

                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          borderTopLeftRadius: "20px",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                          minWidth: "120px",
                        }}
                      >
                        <Autocomplete
                          clearOnEscape={false}
                          clearIcon={null}
                          sx={{
                            ...textfieldTextBlueBorder,
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "10px",
                              height: "40px",
                              padding: "9px !important",
                              "& input": {
                                padding: "8px",
                                fontSize: "14px",
                              },
                              "& .MuiAutocomplete-popupIndicator": {
                                display: "none", // Hides the dropdown icon
                              },
                            },
                          }}
                          options={
                            fieldOptions?.packList?.filter(
                              (option) => option,
                            ) || []
                          } // Filter out invalid entries
                          getOptionLabel={(option) => option || ""} // Use the string value directly
                          inputValue={item?.packing || ""} // Handle input display safely
                          onInputChange={(e, value) => {
                            handleChange(index, "packing", value, e); // Update the form state on input change
                          }}
                          id={`packing-${index}`}
                          onKeyDown={(e) => handleKeyDown(e, index, "packing")}
                          onChange={(e, value) => {
                            if (value) {
                              // Assuming `value` is a string directly
                              console.log(value);
                              handleChange(index, "packing", value);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select pack"
                              error={!!errors.suppliers}
                            />
                          )}
                          renderOption={(props, option) => (
                            <MenuItem {...props} key={option}>
                              {option}
                            </MenuItem>
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          } // Compare values directly
                        />
                      </TableCell>

                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "14.28%",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          placeholder="Stock left"
                          sx={textfieldTextBlueBr}
                          value={item?.stock_left}
                          onChange={(e) => {
                            handleChange(index, "stock_left", e.target.value);
                          }}
                          name="stock_left"
                          fullWidth
                          id={`stock_left-${index}`}
                          onKeyDown={(e) =>
                            handleKeyDown(e, index, "stock_left")
                          }
                          type="number"
                        />
                      </TableCell>

                      {/* Icon Column */}
                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "auto", // Remaining space for icon
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <IconButton
                          sx={{ marginLeft: "8px", marginBottom: "7px" }}
                          // onClick={() => handleRemoveRow(index)}
                        >
                          <CloseIcon
                            sx={{ ...xBtn, width: "28px", height: "28px" }}
                            onClick={() => handleDeleteRow(index)}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Box>

        <Box
          container
          display={"flex"}
          justifyContent={"space-between"}
          sx={{ zIndex: "10" }}
          lg={12}
          marginBottom={"5px"}
        >
          <Grid item></Grid>

          <Grid item>
            <Button
              onClick={handleCreateMedicine}
              className="btn draw-border"
              variant="contained"
              id="submit"
              sx={{
                ...primaryBtnTeal,
                width: "195px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              disabled={loading}
            >
              Create Medicine
            </Button>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default NewMedicines;
